import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TriageUserDataService {

  private triageData: any = {};

  get(key: string): any {
    return this.triageData[key];
  }

  set(key: string, value: any): void {
    this.triageData[key] = value;
  }

  has(key: string): boolean {
    return this.triageData.hasOwnProperty(key);
  }

  clear(): void {
    this.triageData = {};
  }

  getAll(): any {
    return this.triageData;
  }
}
